import { composeClassNames } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { CSSProperties } from "react";
import { Button } from "react-bootstrap";
import Heading from "src/components/Heading";
import Translate from "src/components/Translate";
import Benefit from "src/icons/Benefit";
import Care from "src/icons/Care";
import Free from "src/icons/Free";
import Tax from "src/icons/Tax";
import Watch from "src/icons/Watch";
import Yoga from "src/icons/Yoga";
import Yogamat from "src/icons/Yogamat";
import { sButton } from "src/styles/sButton.module.scss";
import { sGroupTitle } from "src/styles/sGroupTitle.module.scss";
import { sWhyToUseCard } from "src/styles/sWhyToUseCard.module.scss";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  specificContent?: boolean;
};

function WhyToUseCompanies({ style, className, specificContent }: Props) {
  const { locale: lang, push } = useRouter();

  return (
    <>
      <div
        className={composeClassNames([
          sWhyToUseCard,
          className,
          "whyToUse-cards",
        ])}
      >
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Free />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type="h4"
              align="left"
              title={<Translate tKey={`First month free`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`Try a monthly subscription for your employees for free.`}
              />
            </p>
          </div>
        </div>
        {!specificContent && (
          <div className="whyToUse-card">
            <div className="whyToUse-card-image">
              <Benefit />
            </div>
            <div className="whyToUse-card-text">
              <Heading
                type="h4"
                align="left"
                title={<Translate tKey={`Benefit program`} />}
                className={composeClassNames([
                  sGroupTitle,
                  "whyToUse-card-title",
                ])}
              />
              <p>
                <Translate
                  tKey={`Take advantage of interesting discounts and bonuses from our partners.`}
                />
              </p>
            </div>
          </div>
        )}
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Watch />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type="h4"
              align="left"
              title={<Translate tKey={`Home office just fine`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`Use our services at work and at home, according to current needs.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Yogamat />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type="h4"
              align="left"
              title={<Translate tKey={`We will equip your office`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`We will arrange the necessary and create a perfect place for exercise in your company.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Care />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type="h4"
              align="left"
              title={<Translate tKey={`Caring for the team`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p style={{ fontSize: `13px` }}>
              <Translate
                tKey={`Regular shared movement is a great way to bond the team and improve the overall mood in your company.`}
              />
            </p>
          </div>
        </div>

        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Tax />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type="h4"
              align="left"
              title={<Translate tKey={`Tax savings`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`By providing an employee benefit, you can save up to 26% of the total amount.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Yoga />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type="h4"
              align="left"
              title={<Translate tKey={`Individual sessions`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`Our instructors also provide individual care and guidance.`}
              />
            </p>
          </div>
        </div>
      </div>
      <div className={"show-all"}>
        <Button
          variant="primary"
          className={composeClassNames([sButton, className])}
          onClick={() => push("#pricing")}
          style={style}
        >
          <Translate tKey={`Take advantage of the offer`} />
        </Button>
      </div>
    </>
  );
}

export default WhyToUseCompanies;
